import { appShare } from './app'
import composition from '@/composition'
const { store, wxShare } = composition()

export const bangbanConfig = {
  categoryId: 9,
  categoryType: 'DEPUTY',
  brandCode: 'bangban_brand_2023' // 口碑榜code
}

// 视频时间格式化
export const videoDurationTime = (duration) => {
  const time = parseInt(duration / 1000)
  let minute = parseInt(time / 60)
  minute = minute < 10 ? `0${minute}` : minute
  let second = parseInt(time % 60)
  second = second < 10 ? `0${second}` : second
  return `${minute}:${second}`
}

// 帖子进度状态 1已解决 2正在处理 0分享 没有进度
export const setPostProgressState = (progress) => {
  if (progress) {
    if (progress == 'CLOSED' || progress == 'FINISHED') {
      return 1
    } else {
      return 2
    }
  } else {
    return 0
  }
}

// 视频封面图路径
export const videoCoverPath = (path) => {
  return path + '?x-oss-process=video/snapshot,t_10000'
}

// 帮办分享配置
export const getShareInfo = (info) => {
  let { title = '帮办平台', desc = '', url = location.href, imageUrl = 'https://fsnewsres.foshanplus.com/other/20230630/1b123d31be3145218958bed4b6332912.png' } = info || {}

  // 视频快照不处理
  if (imageUrl && !imageUrl.includes('x-oss-process=video')) {
    imageUrl = imageUrl.split('?')[0]
    imageUrl = imageUrl + '?x-oss-process=image/resize,m_pad,h_400,w_500,color_FFFFFF'
  }

  return {
    title,
    desc,
    url,
    imageUrl
  }
}

export const setShare = (info, isEmit) => {
  const { title, desc, url, imageUrl } = getShareInfo(info)
  if (store.state.isApp && isEmit) {
    appShare(title, desc, url)
  } else if (store.state.isWeixin) {
    wxShare(title, desc, imageUrl)
  }
}
